import React from 'react';
import _get from 'lodash/get';

import { Config, LockContainer } from 'components';
import { useBonusCashConfig } from '../../hooks';

export default function ToggleSwitch() {
  const { data, isProcessing, onChangeData } = useBonusCashConfig();

  const isActive = _get(data, 'is_active', false);
  const selectedId = _get(data, 'shopper_group_id', null);

  const isLocked = selectedId !== null;
  const isDisabled = isLocked || isProcessing;

  return (
    <Config.Section>
      <LockContainer locked={isLocked}>
        <Config.Activator
          isActive={isActive}
          onChange={value => onChangeData({ is_active: value })}
          disabled={isDisabled}
        />
      </LockContainer>
    </Config.Section>
  );
}
